import React, { Component } from 'react';
import style from '../share/BookingDetail.module.css';
import TextBoxWithLabel from '../../components/TextBoxWithLabel.js';
import TextAreaWithLabel from '../../components/TextAreaWithLabel.js';

import DefaultBtn from '../../components/DefaultBtn.js';
import CheckBoxWithLabel from '../../components/CheckBoxWithLabel.js';
import axios from 'axios'
import BackDropLoading from '../../components/BackDropLoading.js';

class BookingDetail extends Component {
    constructor(props) {
        //alert("HotelCrate");
        super(props);
        this.state = {
            dataObject: null,
            // validateObject: null,
             loading: true,
            // companyId: this.props.match.params.id
        };
        this.callGetData();
    }


    callGetData() {
        let url = process.env.REACT_APP_API_END_POINT + "/api/BackOffice/BookingDetail";
        // let data = {
        //     Id: this.props.id
        // };

        let data = {};
        data.Id = this.props.Id;

        let appState = this.props.appState;


        console.log(data);

        axios
            .post(url, data, {
                headers: {
                    'Authorization': appState.userObject.Token
                }
            })
            .then(response => {
                this.callGetDataCallBack(response.data);
            })
            .catch(err => {
                console.error(err)
            })
    }
    callGetDataCallBack(data) {
        //console.log("debug");
        //console.log(data);
        this.setState({
            dataObject: { ...data.Data },
            //validateObject: { ...data.Data.validateObject },
            loading: false
        })
    }

    render() {

        let result = [];;
        let d = this.state.dataObject;


        console.log(d);




        if (d !== null) {

            let g =[];

            for(let i=0;i<d.guests.length;i++){
                let guest = d.guests[i];


                g.push(
                    <div key={i}>
                        <div className={style.detailRow}>
                                <div className={style.detailLabel}>Name:</div>
                                <div className={style.detailValue}>{guest.name}</div>
                            </div>
                            <div className={style.detailRow}>
                                <div className={style.detailLabel}>Email:</div>
                                <div className={style.detailValue}>{guest.email}</div>
                            </div>
                            <div className={style.detailRow}>
                                <div className={style.detailLabel}>Phone:</div>
                                <div className={style.detailValue}>{guest.phone}</div>
                            </div>
                            <div className={style.detailRow}>
                                <div className={style.detailLabel}>Company:</div>
                                <div className={style.detailValue}>{guest.company}</div>
                            </div>
                            <div className={style.space20}></div>
                    </div>

                );



            }





            result = (

                <div className={style.ContentArea}>
                    <BackDropLoading show={this.state.loading} key="hotel" />


                    <div className={style.contentBox}>
                        <div className={style.toolRow}>
                            <div className={style.toolBtn} onClick={this.props.back}>
                                <i className="fas fa-arrow-left"></i>
                                        Back
                                </div>
                        </div>
                        <div className={style.detailSection}>
                            <div className={style.detailTitle}>Guest Information</div>
                            {g}
                        </div>


                        <div className={style.detailSection}>
                            <div className={style.detailTitle}>Reservation Information</div>
                            <div className={style.detailRow}>
                                <div className={style.detailLabel}>Reservation No:</div>
                                <div className={style.detailValue}>{d.reservationCode}</div>
                            </div>
                           
                            <div className={style.detailRow}>
                                <div className={style.detailLabel}>Date In:</div>
                                <div className={style.detailValue}>{d.dateIn}</div>
                            </div>
                            <div className={style.detailRow}>
                                <div className={style.detailLabel}>Date Out:</div>
                                <div className={style.detailValue}>{d.dateOut}</div>
                            </div>
                            <div className={style.detailRow}>
                                <div className={style.detailLabel}>Room Type:</div>
                                <div className={style.detailValue}>{d.roomType}</div>
                            </div>
                            <div className={style.detailRow}>
                                <div className={style.detailLabel}>Rooms:</div>
                                <div className={style.detailValue}>{d.numberOfUnits}</div>
                            </div>
                            <div className={style.detailRow}>
                                <div className={style.detailLabel}>Rate Plan:</div>
                                <div className={style.detailValue}>{d.ratePlanName}</div>
                            </div>
                            <div className={style.detailRow}>
                                <div className={style.detailLabel}>Adults:</div>
                                <div className={style.detailValue}>{d.adults}</div>
                            </div>
                            <div className={style.detailRow}>
                                <div className={style.detailLabel}>Children:</div>
                                <div className={style.detailValue}>{d.children}</div>
                            </div>
                            <div className={style.detailRow}>
                                <div className={style.detailLabel}>Book Date:</div>
                                <div className={style.detailValue}>{d.bookingDate}</div>
                            </div>
                            <div className={style.detailRow}>
                                <div className={style.detailLabel}>Status:</div>
                                <div className={style.detailValue}>{d.status}</div>
                            </div>
                        </div>


                    </div>

                </div>

            );
        }


        return result;
    }
}
export default BookingDetail;